import { useEffect, useState } from "react";
import { Routes, Route, Link, useNavigate, useParams } from "react-router-dom";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import AdminCodeDetail from "./AdminCodeDetail";
import AdminLeads from "./AdminLeads";
import { LogOut } from "lucide-react";

const KEY_STORAGE = "instore_admin_key";

export default function AdminApp() {
  const [adminKey, setAdminKey] = useState(null);

  useEffect(() => {
    const k = localStorage.getItem(KEY_STORAGE);
    if (k) setAdminKey(k);
  }, []);

  const onLogin = (k) => {
    localStorage.setItem(KEY_STORAGE, k);
    setAdminKey(k);
  };
  const onLogout = () => {
    localStorage.removeItem(KEY_STORAGE);
    setAdminKey(null);
  };

  if (!adminKey) return <AdminLogin onSuccess={onLogin} />;

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 bg-background border-b border-foreground">
        <div className="flex items-center justify-between px-6 md:px-10 h-14">
          <div className="flex items-center gap-6">
            <Link to="/admin" className="flex items-center gap-3">
              <div className="w-2 h-2 bg-primary rotate-45" />
              <span className="text-xs uppercase tracking-brand font-semibold">IBA Servicing · Admin</span>
            </Link>
            <nav className="flex items-center gap-5 text-xs uppercase tracking-brand">
              <Link to="/admin" className="hover:text-primary" data-testid="nav-codes">Codes</Link>
              <Link to="/admin/leads" className="hover:text-primary" data-testid="nav-leads">Leads</Link>
              <Link to="/" className="text-muted-foreground hover:text-foreground">View Deck →</Link>
            </nav>
          </div>
          <button
            onClick={onLogout}
            data-testid="admin-logout"
            className="flex items-center gap-2 text-xs uppercase tracking-brand hover:text-primary"
          >
            <LogOut className="w-3.5 h-3.5" /> Log out
          </button>
        </div>
      </header>

      <Routes>
        <Route index element={<AdminDashboard adminKey={adminKey} />} />
        <Route path="codes/:code" element={<CodeDetailWrapper adminKey={adminKey} />} />
        <Route path="leads" element={<AdminLeads adminKey={adminKey} />} />
      </Routes>
    </div>
  );
}

function CodeDetailWrapper({ adminKey }) {
  const { code } = useParams();
  const nav = useNavigate();
  return <AdminCodeDetail code={code} adminKey={adminKey} onBack={() => nav("/admin")} />;
}
